/**
 * TodayGoal — daily goal checklist card on a primary-blue gradient background.
 */

import React from 'react';

export interface Goal {
  label: string;
  done: boolean;
}

interface TodayGoalProps {
  goals: Goal[];
}

export const TodayGoal: React.FC<TodayGoalProps> = ({ goals }) => {
  return (
    <div
      className="rounded-2xl p-5"
      style={{
        background: 'linear-gradient(135deg, #5b6cff, #7c8eff)',
        border: '1.5px solid rgba(91,108,255,0.4)',
        boxShadow: '0 4px 24px rgba(91,108,255,0.18)',
      }}
    >
      <p className="font-montserrat font-bold text-sm text-white mb-4">📋 Today's Goals</p>

      <div className="space-y-3">
        {goals.map((goal, i) => (
          <div key={i} className="flex items-start gap-3">
            {/* Checkbox */}
            <div
              className="mt-0.5 w-5 h-5 rounded flex items-center justify-center flex-shrink-0"
              style={{
                background: goal.done ? '#fff' : 'rgba(255,255,255,0.18)',
                border: '1.5px solid rgba(255,255,255,0.45)',
              }}
            >
              {goal.done && (
                <span
                  className="font-bold leading-none"
                  style={{ color: '#5b6cff', fontSize: '11px' }}
                >
                  ✓
                </span>
              )}
            </div>

            {/* Label */}
            <p
              className={`font-open-sans text-sm leading-snug ${
                goal.done ? 'line-through opacity-65 text-white' : 'text-white'
              }`}
            >
              {goal.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
